var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9834 14.9844V11.2051C14.9834 10.873 15.1055 10.5898 15.3496 10.3555C15.5938 10.1211 15.8916 10.0039 16.2432 10.0039C16.5752 10.0039 16.8584 10.1211 17.0928 10.3555C17.3271 10.5898 17.4443 10.873 17.4443 11.2051V14.9844H21.2236C21.5654 14.9844 21.8584 15.1064 22.1025 15.3506C22.3564 15.585 22.4834 15.873 22.4834 16.2148C22.4834 16.5566 22.3564 16.8496 22.1025 17.0938C21.8584 17.3281 21.5654 17.4453 21.2236 17.4453H17.4736V21.2246C17.4736 21.5762 17.3467 21.874 17.0928 22.1182C16.8486 22.3623 16.5557 22.4844 16.2139 22.4844C15.8721 22.4844 15.5791 22.3623 15.335 22.1182C15.1006 21.874 14.9834 21.5762 14.9834 21.2246V17.4453H11.2041C10.8721 17.4453 10.584 17.3281 10.3398 17.0938C10.0957 16.8496 9.97363 16.5566 9.97363 16.2148C9.97363 15.8828 10.0957 15.5947 10.3398 15.3506C10.584 15.1064 10.8721 14.9844 11.2041 14.9844H14.9834Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCollapse);
export default __webpack_public_path__ + "static/media/openCollapse.048ac546c69c508fd1bb7de72f81cb8d.svg";
export { ForwardRef as ReactComponent };